import { gql } from 'urql'

// Counts the user's non-revoked certificates with H&S form and evaluation
// submitted. Must stay in sync with the backfill in the 1782000000000
// migration.
export const GET_USER_QUALIFYING_CERTIFICATE_COUNT = gql`
  query GetUserQualifyingCertificateCount($profileId: uuid!) {
    course_certificate_aggregate(
      where: {
        profileId: { _eq: $profileId }
        isRevoked: { _eq: false }
        participant: {
          healthSafetyConsent: { _eq: true }
          completed_evaluation: { _eq: true }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`
